/** Simulation ticks per second. All sim timing is expressed in whole ticks. */
export const TICK_RATE = 60;

/** Milliseconds per tick, for the frame-rate-independent stepper on the game side. */
export const TICK_MS = 1000 / TICK_RATE;
